import React, {useEffect, useState} from 'react';
import {Modal, Table} from 'antd';
import TestResultModal from './TestResultModal';
import {
    TestPlanExecutionDto,
    TestPlanControllerApi,
    TestExecutionDto,
    TestResultDto,
    TestExecutionDtoRunStatusEnum
} from '../../../api';
import {formatDateTime, renderStatusAmpel} from "../../../utils/Utils";
import {useKeycloakHeader} from "../../../config/Config";

/*
Dieses Modal zeigt die Details einer TestPlan-Ausführung an.
Dabei werden die einzelnen Tests für die Ausführung angezeigt
 */
const TestPlanExecutionDetailsModal: React.FC<{ visible: boolean; testPlanExecutionId: number; onClose: () => void }> = ({
                                                                                                                             visible,
                                                                                                                             testPlanExecutionId,
                                                                                                                             onClose
                                                                                                                         }) => {
    const [testPlanExecution, setTestPlanExecution] = useState<TestPlanExecutionDto>();
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedTestResult, setSelectedTestResult] = useState<TestResultDto>();

    const headers = useKeycloakHeader();
    const testPlanControllerApi = new TestPlanControllerApi();

    useEffect(() => {
        testPlanControllerApi.getTestPlanExecutionForTestPlanExecutionId(testPlanExecutionId, headers)
            .then((axiosResponse) => {
                const testPlanEx: TestPlanExecutionDto = axiosResponse.data;
                if(testPlanEx.testExecutions){
                    const executions: Array<TestExecutionDto> = testPlanEx.testExecutions.map((testExecution: TestExecutionDto) => ({
                        ...testExecution,
                        startTs: formatDateTime(testExecution.startTs),
                        endTs: formatDateTime(testExecution.endTs),
                        resumeTs: formatDateTime(testExecution.resumeTs)
                    }));
                    testPlanEx.testExecutions = executions;
                }

                setTestPlanExecution(testPlanEx);
            })
            .catch((error) => {
                console.error('Fehler beim Abrufen der Daten:', error);
            });
    }, [testPlanExecutionId]);


    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Name',
            dataIndex: ['result', 'name'],
            key: 'result.name'
        },
        {
            title: 'Start',
            dataIndex: 'startTs',
            key: 'startTs',
        },
        {
            title: 'Ende',
            dataIndex: 'endTs',
            key: 'endTs',
            render: (text, record) => (
                <span>{!record.endTs && record.runStatus === TestExecutionDtoRunStatusEnum.Paused ? "Wird fortgesetzt: " + record.resumeTs : record.endTs}</span>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'runStatus',
            key: 'runStatus',
            width: '5%',
            render: (text, record) => (
                <span>{renderStatusAmpel(record.runStatus)}</span>
            ),
        },
    ];

    const handleRowClick = (record) => {
        setSelectedTestResult(record.result);
        setModalVisible(true);
    };


    return (
        <Modal
            title="Details der Testplan-Ausführung"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={1000}
        >
            <Table
                dataSource={testPlanExecution?.testExecutions?.map(execution => ({
                    ...execution,
                    key: execution.id,
                }))}
                columns={columns}
                onRow={(record) => ({
                    onClick: () => {
                        handleRowClick(record);
                    },
                })}
            />
            {selectedTestResult && (
                <TestResultModal visible={modalVisible} testResultId={selectedTestResult.id} onClose={() => setModalVisible(false)} />
            )}
        </Modal>
    );






};

export default TestPlanExecutionDetailsModal;
